import {
  PayoutDestinationType,
  PayoutSettings
} from "@wingspanhq/wingspan-api-sdk";
import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";
import { selectorPayoutSettingsDefaultDestination } from "@selectors/selectorPayoutSettingsDefaultDestination";

export const selectorUseInternationalInstantPayouts = (
  member: IMember,
  monitoredEntity?: onboardingApiSpec.CustomerEntity,
  payoutSettings?: PayoutSettings
) => {
  const defaultDestination = payoutSettings
    ? selectorPayoutSettingsDefaultDestination(payoutSettings)
    : undefined;

  if (defaultDestination?.type === PayoutDestinationType.INTERNAL_ACCOUNT) {
    return true;
  }

  if (monitoredEntity?.country) {
    return monitoredEntity.country === "CA";
  }

  return member.profile.address?.country === "CA";
};
